import Empresa from './empresa'

export default class Filial {
  constructor(id, documento, nome) {
    this.id = id
    this.documento = documento
    this.nome = nome
    this.empresa = new Empresa()
  }
}
